import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { FULL_URL } from '../config/Master';
import { removeLocalItem } from '../common';
import TextLink from '../components/common/TextLink';
import TextLinkV2 from '../components/common/TextLinkV2';
import { spacing } from '../style';

const MessageContainer = styled('div')({
  textAlign: 'center',
  ...spacing.MARGIN_TOP_LG,
  marginBottom: '9px',
  marginTop: 0,
});

interface NeedAccountMessageProps {
  customStyle?: React.CSSProperties;
}

const NeedAccountMessage = ({ customStyle }: NeedAccountMessageProps): ReactElement => {
  return (
    <MessageContainer style={customStyle}>
      Need an account? {/* @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389 */}
      <TextLink
        onClick={() => {
          removeLocalItem('join_predata');
          removeLocalItem('join_onboarding_predata');
          window.location.href = '/join';
        }}
        style={{ fontSize: 16, fontWeight: 600 }}
      >
        Create one here
      </TextLink>
      . <br /> Please review our{' '}
      <TextLinkV2 rel="noopener" href={`${FULL_URL}/community-guidelines`} target="_blank">
        {' '}
        community guidelines{' '}
      </TextLinkV2>
    </MessageContainer>
  );
};

export default NeedAccountMessage;
